import { gql } from '@apollo/client';
import { ErrorMessageInfo } from '@retainerclub/shared-api';
import { TaxTransactionSyncInfo } from '../fragments';

export default gql`
  mutation ActionReconcileTaxTransactionSync(
    $input: TaxTransactionSyncReconcileActionInput!
  ) {
    actionTaxTransactionSyncReconcile(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      sync {
        ...TaxTransactionSyncInfo
      }
      reconciliation {
        status
        providerStatus
        errorCode
        differences
        providerResponse
      }
    }
  }
  ${ErrorMessageInfo}
  ${TaxTransactionSyncInfo}
`;
